import { useMemo } from 'react';
import { useFilterContext } from 'src/contexts/FilterContext';
import { MODELLED_CONV_NAME, WEIGHTED_CPA_NAME } from '../utils/constants';
import { getDataKeys, MetricsData, useMetrics } from './useMetrics';

export const useMetricsByCampaignGroup = () => {
  const { campaignGroups } = useFilterContext();
  const { data: campaignData, isError, isLoading } = useMetrics('byCampaign');

  const dataKeys = getDataKeys(false, false);

  const data = useMemo(() => {
    const selectedGroups = campaignGroups.filter((g) => g.selected);
    if (selectedGroups.length === 0 || campaignData.length === 0) return [];

    return selectedGroups.map((group) => {
      const allowedNames = new Set(group.campaignNames);
      const matching = campaignData.filter((d) => allowedNames.has(d.key));

      const modelledConversions = matching.reduce(
        (sum, d) => sum + d[MODELLED_CONV_NAME],
        0,
      );
      const spend = matching.reduce((sum, d) => sum + d.Spend, 0);
      const impressions = matching.reduce((sum, d) => sum + d.Impressions, 0);
      const clicks = matching.reduce((sum, d) => sum + d.Clicks, 0);
      const cpa = modelledConversions > 0 ? spend / modelledConversions : 0;

      return {
        key: group.groupName,
        [MODELLED_CONV_NAME]: modelledConversions,
        Spend: spend,
        Impressions: impressions,
        CPA: cpa,
        [WEIGHTED_CPA_NAME]: null,
        Clicks: clicks,
        Frequency: null,
      } as MetricsData;
    });
  }, [campaignGroups, campaignData]);

  return { data, isError, isLoading, dataKeys };
};
